/*
 * GameResult.ts
 */
export class GameResult {
    constructor(responseCode, data) {
        this.responseCode = responseCode;
        this.data = data;
    }
    getResponseCode() {
        return this.responseCode;
    }
    getData() {
        return this.data;
    }
}
//# sourceMappingURL=GameResult.js.map